module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone.be6bc91f.svg";